import { render, staticRenderFns } from "./SocialButton.vue?vue&type=template&id=304af947&"
import script from "./SocialButton.vue?vue&type=script&lang=ts&"
export * from "./SocialButton.vue?vue&type=script&lang=ts&"
import style0 from "./SocialButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports